import React from 'react'
import { withAuth } from '../../auth'
import Proptypes from 'prop-types'
import { styled } from '@mui/material/styles'

const PREFIX = 'Logout'
const classes = {
  container: `${PREFIX}-container`,
}
const Container = styled('div')(() => ({
  [`&.${classes.container}`]: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
}))

const Logout = props => {
  const { auth } = props

  const click = () => {
    // eslint-disable-next-line no-undef
    const ok = window.confirm('Are you sure you want to logout?')
    if (ok) {
      // eslint-disable-next-line no-undef
      auth.logout(window.location.origin)
    }
  }

  return (
    <Container className={classes.container} onClick={click}>
      Logout
    </Container>
  )
}
Logout.propTypes = {
  auth: Proptypes.object,
}
export default withAuth(Logout)
